import { CircularProgress } from '@mui/material';
import { useState } from 'react'
import { toast } from 'react-toastify'
import { PRESUPUESTOS_API } from '../../../shared/services/presupuestos';

export const ObservacionesComercial = ({presupuesto, onClose}) => {
  const [observaciones, setObservaciones] = useState(presupuesto.observaciones_comercial || '');
  const [isLoading, setIsLoading] = useState(false);

  const updateObservaciones = async () => {
    setIsLoading(true)
    try {
      const res = await PRESUPUESTOS_API.updateObservacionComercial({
        presupuesto_id: presupuesto.id,
        observaciones_comercial: observaciones
      })
      if(res.success) {
        return onClose()
      }
    } catch (e) {
      toast.error(e.message);
    } finally {
      setIsLoading(false)
    }
  }
  return (
    <div className='observaciones-comercial'>
        <textarea value={observaciones} onChange={(e) => setObservaciones(e.target.value)} />
        <button className='btn btn-primary' onClick={updateObservaciones}>
          { isLoading 
            ? <CircularProgress color='inherit' size='22px' /> 
            : 'Guardar'}
        </button>
    </div>
  )
}
